(async () => {
  document.querySelector('.js-restock-form').addEventListener('submit', function (event) {
    event.preventDefault();
    const submitButton = document.querySelector('.js-restock-form-button');
    submitButton.disabled = true;
    submitButton.textContent = 'Submitting...';

    fetch('https://www.fpapplications.com/restock', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-store-id': 1,
      },
      body: JSON.stringify({
        variant_id: event.target.variant_id.value,
        email: event.target.email.value,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        submitButton.disabled = false;
        submitButton.textContent = 'Notify Me';
        if (data.success) {
          document.querySelector('.js-restock-form').style.display = 'none';
          document.getElementById('restock-notification-msg-success').style.display = 'block';
          if (!window.location.pathname.includes('/vevor')) {
            renderFollowUpModal(event.target.email.value);
          }
        } else {
          document.getElementById('restock-notification-msg-error').style.display = 'block';
        }
      })
      .catch(() => {
        submitButton.disabled = false;
        submitButton.textContent = 'Notify Me';
        document.getElementById('restock-notification-msg-error').style.display = 'block';
      });
  });

  function renderFollowUpModal(emailAddress) {
    const modal = document.createElement('div');
    modal.classList.add('restock-follow-up-modal');
    modal.innerHTML = `
        <form class="restock-follow-up-modal__inner js-restock-follow-up-form">
          <button class="restock-follow-up-modal__close-button js-close-restock-modal">&times;</button>
          <h2 class="restock-follow-up-modal__title">Would you like our team to suggest a similar model for you?</h2>
          <div class="pdp__main__callback__modal__heading__online-row">
            <div class="pdp__main__callback__modal__heading__guy pdp__main__callback__modal__heading__guy--desktop">
              <div style="position:relative; border-radius: 50%; overflow: hidden; width: 48px; height: 48px;">
                <img src="/cdn/shop/t/225/assets/call-center-rep_300x300.jpeg?v=29173002167000123341745607346" alt="Call Center Representative" style="border-radius: 50%; height: 100%; width: 100%;" width="48" height="48">
              </div>
              <p class="online-indicator js-online-indicator">
                <span class="online-indicator__dot" style="">
                  <span class="online-indicator__blink"></span>
                </span>
                <span class="online-indicator__status">Online</span>
              </p>
            </div>
            <div>
              <p class="pdp__main__callback__modal__subheading pdp__main__callback__modal__subheading--desktop">
                One of our seasoned, Texas-based product experts will reach out to assist you shortly.
              </p>
              <p class="pdp__main__callback__modal__subheading pdp__main__callback__modal__subheading--mobile">
                One of our seasoned, Texas-based product experts will reach out to assist you shortly.
              </p>
            </div>
          </div>
          <label for="restock-follow-up-modal__phone-input" class="restock-follow-up-modal__phone-label">Phone number</label>
          <input type="tel" class="restock-follow-up-modal__phone-input" name="phone" id="restock-follow-up-modal__phone-input" placeholder="Your phone number (optional)" class="restock-follow-up-modal__phone-input" required />
          <input type="hidden" name="inquiry" value="Restock notification sign up (${emailAddress}) - Interested in finding an alternative to ${globalProduct.title}">
          <input type="hidden" name="product_title" value="${globalProduct.title}">
          <input type="hidden" name="sku" value="${globalProduct.sku}">
          <input
            id="callback-price"
            type="hidden"
            name="price"
            value="${globalProduct.price}"
          >
          <input type="hidden" name="url" value="https://factorypure.com${globalProduct.url}">
          <input type="hidden" name="domain" value="factorypure.com">
          <input type="hidden" name="name" value="Not provided">
          <div style="display: flex; gap: 8px;">
            <button type="button" class="restock-follow-up-modal__no-thanks-button js-close-restock-modal">No thanks</button>
            <button class="restock-follow-up-modal__submit-button js-restock-follow-up-button">Yes please!</button>
          </div>
        </form>
    `;

    const closeButtons = Array.from(modal.querySelectorAll('.js-close-restock-modal'));
    closeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        document.body.removeChild(modal);
      });
    });

    modal.addEventListener('mousedown', function (e) {
      const inner = modal.querySelector('.restock-follow-up-modal__inner');
      if (e.target === modal && !inner.contains(e.target)) {
        document.body.removeChild(modal);
      }
    });

    const submitButton = modal.querySelector('.js-restock-follow-up-button');

    modal.querySelector('.js-restock-follow-up-form').addEventListener('submit', async function (e) {
      e.preventDefault();
      submitButton.disabled = true;
      submitButton.textContent = 'Submitting...';
      const formData = new FormData(this);
      const data = Object.fromEntries(formData.entries());
      for (const entry of formData.entries()) {
        if (entry[0] === 'phone') {
          data[entry[0]] = prettyPrintPhoneNumber(entry[1]);
        }
      }
      if (!this.checkValidity()) {
        this.reportValidity();
        return;
      }

      try {
        const response = await fetch('https://www.fpapplications.com/callbackRequests', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-store-id': '1',
          },
          body: JSON.stringify(data),
        });

        if (response.ok) {
          window.toast.success('Your callback request has been submitted successfully!', 5000);
          this.reset();
          document.body.removeChild(modal);
        } else {
          window.toast.error('There was an error submitting your request. Please try again.', 5000);
        }
        submitButton.disabled = false;
        submitButton.textContent = 'Yes please!';
      } catch (error) {
        console.error('Error:', error);
        window.toast.error('There was an error submitting your request. Please try again.', 5000);
        submitButton.disabled = false;
        submitButton.textContent = 'Yes please!';
      }
    });
    document.body.appendChild(modal);
    (window.toggleIndicators || (() => {}))();
  }

  function prettyPrintPhoneNumber(number) {
    if (!number) return '';
    number = number.replace(/\D/g, '');
    if (number.length === 10) {
      return `(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(6)}`;
    } else if (number.length === 11 && number.startsWith('1')) {
      return `+1 (${number.slice(1, 4)}) ${number.slice(4, 7)}-${number.slice(7)}`;
    }
    return number;
  }
})();
